import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function RefundPolicyPage() {
  return (
    <section className="legal-page" aria-labelledby="refund-heading">
      <div className="legal-inner">
        <h1 id="refund-heading">Refund Policy</h1>
        <p className="legal-updated">Last updated: 8 August 2026</p>

        <p>
          This refund policy explains how payments and cancellations work on SnapScrap for scrap
          posters and collectors.
        </p>

        <h2>Posting scrap</h2>
        <p>
          Posting scrap on SnapScrap is free. If a paid add-on or priority listing fee was charged
          and the service was not delivered, you may request a refund within 14 days.
        </p>

        <h2>Collection payments</h2>
        <p>
          Any agreed collection fee or scrap value is confirmed between the poster and collector
          before pickup. If a paid collection does not take place due to SnapScrap platform error,
          contact us for a review.
        </p>

        <h2>Cancellations</h2>
        <ul>
          <li>Cancel a free scrap post at any time before a collector is confirmed</li>
          <li>If a collector is already assigned, cancel as soon as possible via Contact</li>
          <li>Repeated no-shows may result in account restrictions</li>
        </ul>

        <h2>How to request a refund</h2>
        <p>
          Email <a href="mailto:cs@snapscrap.co.uk">cs@snapscrap.co.uk</a> or use our{' '}
          <Link to="/contact">Contact</Link> form with your booking/listing details and reason for
          the request. We aim to respond within 2 working days.
        </p>
      </div>
    </section>
  );
}
